import { NavigationCursorService } from 'src/app/nav-overlay/navigation-cursor.service';
import { Timestamp } from '@angular/fire/firestore';
import { MappingsServiceSettings } from 'src/app/nav-processing/mappings/mappings.model';
import { VoiceServiceSettings } from '../voice/voice.model';
import { NavigationCursorServiceSettings } from 'src/app/nav-overlay/navigation-cursor.model';
import { GeneralSettingsState, NavSettingsBundle, SettingsBlock } from '../manual-settings/manual-settings.model';
import { FirestoreDocTemplate } from '../database/firestore/firestore.service';

export interface Profile extends FirestoreDocTemplate{
  name: string; // Name of the profile
  mappingsServiceSettings?: MappingsServiceSettings; // Deprecated - Legacy for versions prior to 0.4
  voiceServiceSettings: VoiceServiceSettings; // Deprecated - Legacy for versions prior to 0.4
  navigationCursorSettings?: NavigationCursorServiceSettings; // Deprecated - Legacy for versions prior to 0.4
  visionServiceSettings?: any; // Deprecated - Legacy for versions prior to 0.4
  
  navSettingsBundle?: NavSettingsBundle;
  generalSettings?: Array<Array<SettingsBlock>>; // First level is the menu category, second level is the settings blocks of each page
  generalSettingsState?: GeneralSettingsState;
  
  ownerUid?: string;
  docId?: string;
  historyOf?: string; // Id of the profile that this profile is a history of
  status: ProfileStatus; // Status of the profile
  version: number;
}

export enum ProfileStatus {
  Available = 'available',
  Active = 'active',
  History = 'history', // History for restoring past versions. May be deleted automatically
  Recovery = 'recovery', // History for restoring past versions. Can't be deleted automatically
  Deleted = 'deleted',
  Experimental = 'experimental', // Not shown in the UI, only for testing new features
}